module.exports = __webpack_public_path__ + "static/media/whitePower.b133c6ad.svg";